/* models/datetime_picker.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    const tslib_1 = require("tslib");
    const flatpickr_1 = tslib_1.__importDefault(require("50d3473f3f") /* flatpickr */);
    const input_widget_1 = require("@bokehjs/models/widgets/input_widget");
    const dom_1 = require("@bokehjs/core/dom");
    const enums_1 = require("@bokehjs/core/enums");
    const types_1 = require("@bokehjs/core/util/types");
    const inputs = tslib_1.__importStar(require("@bokehjs/styles/widgets/inputs.css"));
    const flatpickr_css_1 = tslib_1.__importDefault(require("@bokehjs/styles/widgets/flatpickr.css"));
    function _convert_date_list(value) {
        const result = [];
        for (const item of value) {
            if (types_1.isString(item))
                result.push(item);
            else {
                const [from, to] = item;
                result.push({ from, to });
            }
        }
        return result;
    }
    class DatetimePickerView extends input_widget_1.InputWidgetView {
        connect_signals() {
            super.connect_signals();
            const { value, min_date, max_date, disabled_dates, enabled_dates, position, inline, enable_time, enable_seconds, military_time, date_format, mode } = this.model.properties;
            this.connect(value.change, () => { var _a; return (_a = this._picker) === null || _a === void 0 ? void 0 : _a.setDate(this.model.value); });
            this.connect(min_date.change, () => { var _a; return (_a = this._picker) === null || _a === void 0 ? void 0 : _a.set("minDate", this.model.min_date); });
            this.connect(max_date.change, () => { var _a; return (_a = this._picker) === null || _a === void 0 ? void 0 : _a.set("maxDate", this.model.max_date); });
            this.connect(disabled_dates.change, () => { var _a; return (_a = this._picker) === null || _a === void 0 ? void 0 : _a.set("disable", this.model.disabled_dates); });
            this.connect(enabled_dates.change, () => { var _a; return (_a = this._picker) === null || _a === void 0 ? void 0 : _a.set("enable", this.model.enabled_dates); });
            this.connect(position.change, () => { var _a; return (_a = this._picker) === null || _a === void 0 ? void 0 : _a.set("position", this.model.position); });
            this.connect(inline.change, () => { var _a; return (_a = this._picker) === null || _a === void 0 ? void 0 : _a.set("inline", this.model.inline); });
            this.connect(enable_time.change, () => { var _a; return (_a = this._picker) === null || _a === void 0 ? void 0 : _a.set("enableTime", this.model.enable_time); });
            this.connect(enable_seconds.change, () => { var _a; return (_a = this._picker) === null || _a === void 0 ? void 0 : _a.set("enableSeconds", this.model.enable_seconds); });
            this.connect(military_time.change, () => { var _a; return (_a = this._picker) === null || _a === void 0 ? void 0 : _a.set("time_24hr", this.model.military_time); });
            this.connect(mode.change, () => { var _a; return (_a = this._picker) === null || _a === void 0 ? void 0 : _a.set("mode", this.model.mode); });
            this.connect(date_format.change, () => { var _a; return (_a = this._picker) === null || _a === void 0 ? void 0 : _a.set("dateFormat", this.model.date_format); });
        }
        remove() {
            var _a;
            (_a = this._picker) === null || _a === void 0 ? void 0 : _a.destroy();
            super.remove();
        }
        styles() {
            return [...super.styles(), flatpickr_css_1.default];
        }
        render() {
            var _a, _b;
            if (this._picker != null)
                return;
            super.render();
            this.input_el = dom_1.input({ type: "text", class: inputs.input, disabled: this.model.disabled });
            this.group_el.appendChild(this.input_el);
            this._picker = flatpickr_1.default(this.input_el, {
                defaultDate: this.model.value,
                minDate: (_a = this.model.min_date) !== null && _a !== void 0 ? _a : undefined,
                maxDate: (_b = this.model.max_date) !== null && _b !== void 0 ? _b : undefined,
                inline: this.model.inline,
                position: this.model.position,
                disable: _convert_date_list(this.model.disabled_dates),
                enable: _convert_date_list(this.model.enabled_dates),
                enableTime: this.model.enable_time,
                enableSeconds: this.model.enable_seconds,
                time_24hr: this.model.military_time,
                dateFormat: this.model.date_format,
                mode: this.model.mode,
                onClose: (selected_dates, date_string, instance) => this._on_close(selected_dates, date_string, instance),
            });
        }
        _on_close(_selected_dates, date_string, _instance) {
            if (this.model.mode == "range" && !date_string.includes("to"))
                return;
            this.model.value = date_string;
            this.change_input();
        }
    }
    exports.DatetimePickerView = DatetimePickerView;
    DatetimePickerView.__name__ = "DatetimePickerView";
    class DatetimePicker extends input_widget_1.InputWidget {
        constructor(attrs) {
            super(attrs);
        }
        static init_DatetimePicker() {
            this.prototype.default_view = DatetimePickerView;
            this.define(({ Boolean, String, Array, Tuple, Or, Nullable }) => {
                const DateStr = String;
                const DatesList = Array(Or(DateStr, Tuple(DateStr, DateStr)));
                return {
                    value: [String],
                    min_date: [Nullable(String), null],
                    max_date: [Nullable(String), null],
                    disabled_dates: [DatesList, []],
                    enabled_dates: [DatesList, []],
                    position: [enums_1.CalendarPosition, "auto"],
                    inline: [Boolean, false],
                    enable_time: [Boolean, true],
                    enable_seconds: [Boolean, true],
                    military_time: [Boolean, true],
                    date_format: [String, "Y-m-d H:i:S"],
                    mode: [String, "single"],
                };
            });
        }
    }
    exports.DatetimePicker = DatetimePicker;
    DatetimePicker.__name__ = "DatetimePicker";
    DatetimePicker.__module__ = "panel.models.datetime_picker";
    DatetimePicker.init_DatetimePicker();
}
